import Text from '../../../../Text'

import { QA_NAME_CALENDAR_GRID_BLOCK_SECONDARY_LABEL } from './CalendarGridWeekBlockContent.constants'

import * as styles from './CalendarGridWeekBlockContent.module.css'

function CalendarGridWeekBlockContent({
  secondaryLabel,
  timeLabel,
  title,
  onClickSecondaryLabel,
}) {
  return (
    <>
      <Text className={styles.label}>{timeLabel}</Text>
      {title ? <Text className={styles.title}>{title}</Text> : null}
      {secondaryLabel ? (
        <Text
          isSecondary
          className={styles.label}
          qaName={QA_NAME_CALENDAR_GRID_BLOCK_SECONDARY_LABEL}
          onClick={onClickSecondaryLabel}
        >
          {secondaryLabel}
        </Text>
      ) : null}
    </>
  )
}

export default CalendarGridWeekBlockContent
